export enum OBJECTIVE_ACQUISITION_STATUS {
  ACQUIRED = "acquired",
  IN_PROGRESS = "in_progress",
  NOT_ACQUIRED = "not_acquired",
}

export enum ACTION_URGENCY_LEVEL {
  NOT_AVAILABLE = "not_available",
  DONE = "done",
  LOW = "low",
  MEDIUM = "medium",
  HIGH = "high",
}

export enum TRAINING_FOLLOW_UP_STATUS {
  SCHEDULED = "scheduled",
  IN_PROGRESS = "in_progress",
  COMPLETED = "completed",
  CANCELLED = "cancelled",
}

export const TRAINING_FOLLOW_UP_STATUS_LABEL: Record<TRAINING_FOLLOW_UP_STATUS, string> = {
  [TRAINING_FOLLOW_UP_STATUS.SCHEDULED]: "Non débuté",
  [TRAINING_FOLLOW_UP_STATUS.IN_PROGRESS]: "En cours",
  [TRAINING_FOLLOW_UP_STATUS.COMPLETED]: "Terminé",
  [TRAINING_FOLLOW_UP_STATUS.CANCELLED]: "Annulé",
};
